module.exports = __webpack_public_path__ + "img/face34.3f611023.gif";